import React, { useEffect, useState } from "react";
import Card from "components/Card/Card";
import axios from "axios";
import apiUrl from "../../../variables/api";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  Text,
  Flex,
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
  Button,
  Textarea,
  RadioGroup,
  Stack,
  SimpleGrid,
  AbsoluteCenter,
  Center,
  useColorMode,
  useColorModeValue,
  Skeleton,
} from "@chakra-ui/react";
import { Field, Form, Formik } from "formik";
import CustomCheckbox from "../../../components/Checkbox/CustomCheckbox";
import ReactSelect from "react-select";
import darkStyles from "variables/darkStyles";

const initialValues = {
  start: new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, -8),
  end: "",
  person: null,
  reason: "",
  proof: "",
};

const validate = (values) => {
  const errors = {};
  const requiredFields = Object.keys(initialValues);

  requiredFields.forEach((field) => {
    if (!values[field]) {
      errors[field] = "To pole jest obowiazkowe";
    }
  });

  return errors;
};

function Page() {
  const { colorMode } = useColorMode();
  const [formData, setFormData] = useState(initialValues);

  const [peoples, setPeoples] = useState([]);
  useEffect(() => {
    axios
      .get(apiUrl + "/data/peoples", {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        console.log(response.data);
        setPeoples(
          response.data.filter(
            (person) => person.value !== localStorage.getItem("id")
          )
        );
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  const formikRef = React.useRef();

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    console.log("Dane formularza", values);
    await setFormData(values);
    console.log("Wysyłanie formularza", formData);

    axios
      .post(apiUrl + "/data/s4", values, {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        if (response.data.success || response.status === 200) {
          formikRef.current.resetForm();
          formikRef.current.setSubmitting(false);
          return toast.success("Pomyślnie wysłano s4");
        } else {
          formikRef.current.setSubmitting(false);
          return toast.error("Napotkano błąd podczas wysyłania s4");
        }
      })
      .catch((error) => {
        console.error(error);
        formikRef.current.setSubmitting(false);
        toast.error("Napotkano błąd podczas połączenia z API");
      });
  };

  return (
    <Flex flexDirection="column" pt={{ base: "120px", md: "75px" }}>
      <Card minH="125px">
        <Formik
          initialValues={initialValues}
          validate={validate}
          // validateOnChange={false}
          // validateOnBlur={false}
          onSubmit={handleSubmit}
          innerRef={formikRef}
        >
          {({ isSubmitting, formik }) => (
            <Form>
              <SimpleGrid
                columns={{ sm: 1, md: 2, xl: 4 }}
                spacing="24px"
                mb="20px"
              >
                <Field name="start">
                  {({ field, form }) => (
                    <FormControl
                      id="start"
                      isRequired
                      isInvalid={form.errors.start && form.touched.start}
                    >
                      <FormLabel>Od</FormLabel>
                      <Input type="datetime-local" {...field} />
                      <FormErrorMessage>{form.errors.start}</FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Field name="end">
                  {({ field, form }) => (
                    <FormControl
                      id="end"
                      isRequired
                      isInvalid={form.errors.end && form.touched.end}
                    >
                      <FormLabel>Do</FormLabel>
                      <Input type="datetime-local" {...field} />
                      <FormErrorMessage>{form.errors.end}</FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Field name="person">
                  {({ field, form }) => (
                    <FormControl
                      id="person"
                      isRequired
                      isInvalid={form.errors.person && form.touched.person}
                    >
                      <FormLabel>Użytkownik</FormLabel>
                        <ReactSelect
                          {...field}
                          noOptionsMessage={() => "Brak dostępnych opcji"}
                          options={peoples}
                          isLoading={peoples.length === 0}
                          placeholder="Wybierz..."
                          styles={darkStyles()}
                          value={form.values.person}
                          onChange={(selectedOptions) => {
                            form.setFieldValue(field.name, selectedOptions);
                          }}
                        />
                      <FormErrorMessage>{form.errors.person}</FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Field name="reason">
                  {({ field, form }) => (
                    <FormControl
                      id="reason"
                      isRequired
                      isInvalid={form.errors.reason && form.touched.reason}
                    >
                      <FormLabel>Powód</FormLabel>
                      <Input {...field} placeholder="Podaj powód" />
                      <FormErrorMessage>{form.errors.reason}</FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Field name="proof">
                  {({ field, form }) => (
                    <FormControl
                      id="proof"
                      isRequired
                      isInvalid={form.errors.proof && form.touched.proof}
                    >
                      <FormLabel>Dowód</FormLabel>
                      <Textarea {...field} placeholder="Podaj dowód" maxH={"500px"}/>
                      <FormErrorMessage>{form.errors.proof}</FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
              </SimpleGrid>

              <Button
                mt={4}
                colorScheme="red"
                isLoading={isSubmitting}
                type="submit"
              >
                Wyślij
              </Button>
            </Form>
          )}
        </Formik>
      </Card>
    </Flex>
  );
}

export default Page;
